var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.4 8.32a1.48 1.48 0 0 0-.56-.32l-.13.8a2.28 2.28 0 0 1 .92 1.27c.28.92-3.16.74-4.35.76A107.68 107.68 0 0 1 3 10.92c-.74-.07-.41-.26-.29-.83.18-.8.21-1.07.77-1.36a.3.3 0 0 0-.13-.57c-.89.33-1.05.78-1.35 1.75-.1.39-.41.84-.12 1.3.56.61 2.86.73 5.31 1 3.85.35 6.69-.15 10.11-.33 1.27-.09 3.25 0 4.42-.6 1.36-.68.81-2.01-.32-2.96Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9.07a.35.35 0 0 0 .33.34c.59 0 .22-.78.38-3A6 6 0 0 1 5 4.71c1.19-3.15 5.3-4.19 8.33-3.58a6.12 6.12 0 0 1 3.14 1.31 4.33 4.33 0 0 1 1.35 1.11 6 6 0 0 1 1.12 2.54 9.85 9.85 0 0 1 .22 2.63 4 4 0 0 0-1.09 0c-.15-.38.06-7.08-7.32-6.35a5.69 5.69 0 0 0-3.32 1.78 5.59 5.59 0 0 0-1 2.14 11.6 11.6 0 0 0 0 3.15 4.61 4.61 0 0 1-1.79.29c-.14 0-.68.86 1 .72 2.15-.18 1.63-.44 1.62-2.33l0-1.07a3.76 3.76 0 0 1 2.07-3.3 5.62 5.62 0 0 1 6.17 1c2 2.11.71 4.46 2.13 5.06.74.32 2.33.25 2.53-.51a15.3 15.3 0 0 0-.1-3.3 6.18 6.18 0 0 0-1.32-3 4.88 4.88 0 0 0-1.37-1.2A7.6 7.6 0 0 0 13.51.14a10.34 10.34 0 0 0-6.63 1.14 6.23 6.23 0 0 0-2.57 3.17C3.78 5.8 4 8.88 4 9.07Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.56 7.87a.3.3 0 0 0 .07-.59 21.25 21.25 0 0 0-7.63.2c-.55.21-.41.63 0 .6l.49 0a60.58 60.58 0 0 0 7.07-.21Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.36 14.57a15.11 15.11 0 0 0-.28-2.1c0-.18 0-.7-.43-.7a.34.34 0 0 0-.33.34c0 .06.34 3.54.36 3.54a21 21 0 0 1-.51 5.26 1.85 1.85 0 0 1-1.55 1.41c-.34.08-2.46.37-3.06.39-1 0-2 0-2.93.05a39.52 39.52 0 0 1-6.25 0 30.59 30.59 0 0 1-3.55-.12c-1.71-.38-1.55-3-1.52-3s.12-6.43.15-7.46c0-.23-.47-.69-.63-.15a71.41 71.41 0 0 0-.3 8.74c.37 3.23 3.39 2.81 5.74 3.06a35.59 35.59 0 0 0 6.45.05 31.44 31.44 0 0 0 4.2-.25c1.85-.39 3.18-.14 4-2.11a5.66 5.66 0 0 0 .4-1.78 27.06 27.06 0 0 0 .04-5.17Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07 16.91c2.65.55 12.88.53 15.43.39a11.55 11.55 0 0 0 1.63-.21.38.38 0 0 0-.17-.73c-4.12.43-3.41-.23-13.5-.09a22.31 22.31 0 0 1-3.27-.05l-1-.14c-.38.09-.32.47 0 .65Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83 14.18c0 1.09 2 1.11 2 0s-2.03-1.18-2 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26 14.18c0 1.09 2 1.11 2 0s-2.02-1.18-2 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83 19.44c0 1.16 2 1.18 2 0s-2.03-1.23-2 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26 19.44c0 1.16 2 1.18 2 0s-2.02-1.23-2 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataProtection);
export default __webpack_public_path__ + "static/media/data-protection.c2912d4d442251ce9da3e857e313bbe3.svg";
export { ForwardRef as ReactComponent };